import { render, staticRenderFns } from "./DisplayModal.vue?vue&type=template&id=7d60f435&scoped=true"
import script from "./DisplayModal.vue?vue&type=script&lang=js"
export * from "./DisplayModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d60f435",
  null
  
)

export default component.exports